import React from 'react';
import ReactDOM from 'react-dom';
import './componentes/dashboard/css/nav.css';
import App from './App';


ReactDOM.render(<App />, document.getElementById('root'));


